import React from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";

/**
 * Confirmation dialog: `children` is the question; `onConfirm` runs then the
 * dialog closes with `onClose` (also on cancel, Escape or a click outside).
 * `danger` styles the confirm button for destructive actions.
 */
const ConfirmDialog = ({ open, onClose, onConfirm, confirmLabel, danger, children }) => {
  const { t } = useTranslation();
  return (
    <Modal show={open} onHide={onClose} centered dialogClassName="ui-modal ui-confirm">
      <Modal.Body>
        <div className="ui-confirm-body">
          <span className="ui-confirm-icon" data-danger={danger || undefined} aria-hidden="true">
            <i className={danger ? "ri-delete-bin-line" : "ri-question-line"}></i>
          </span>
          <div className="ui-confirm-text">{children}</div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="ui-btn ui-btn-secondary" onClick={onClose}>
          {t("Cancel")}
        </button>
        <button
          type="button"
          className={danger ? "ui-btn ui-btn-danger" : "ui-btn"}
          onClick={() => {
            onConfirm();
            onClose();
          }}
          autoFocus
        >
          {confirmLabel}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDialog;
